<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader hero>
      <TextHeading variant="subtitle" color="secondary">Latest</TextHeading>
      <TextHeading variant="xl" block>We've removed plastic wrapping from our flower bouquets</TextHeading>
    </PageHeader>
    <SubMenuMobile/>
    <PageGrid sidebar sharetools>
      <PageSide>
        <SideNav/>
        <KeyUpcomingDates/>
        <CardDownload title="Corporate Responsibility 2018/2019" shape="rectangle"/>
      </PageSide>
      <PageMain>
        <ShareLinksArticle desktop></ShareLinksArticle>
        <HeroImage></HeroImage>
        <TextProse>
          <p>Plastic is the environmental issue everyone has been talking about. In 2017, BBC's Blue Planet demonstrated the detrimental harm leaked plastics can have on the marine environment and its contribution to climate change.</p>
          <p>We're taking responsibility for the plastic we use, in 2018, we announced a commitment that by 2025 all own brand plastic packaging will be recyclable, reusable or compostable. As signatories to WRAP's UK Plastics PACT, we will work in collaboration with WRAP, other signatoriesand the industry so that together, by 2025, we aim to:</p>
          <ul>
            <li>Eliminate problematic or unnecessary single-use packaging through redesign, innovation or alternative (re-use) delivery models;</li>
            <li>Ensure that in our packaging we have 30% average recycled content across all plastic packaging.</li>
          </ul>
          <blockquote>
            <p>It is predicted that by 2050, there will be more plastic in the ocean than fish.</p>
          </blockquote>
          <p>In the short term, we will target problematic plastic materials for Morrisons own brand and Market Street products including:</p>
          <ul>
            <li>Black plastic packaging.</li>
            <li>Polyvinyl Chloride (PVC) packaging.</li>
          </ul>
        </TextProse>
        <ShareLinksArticle mobile></ShareLinksArticle>
        <RelatedArticles/>
      </PageMain>
    </PageGrid>
    <FooterInfo></FooterInfo>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import FooterInfo from '../components/FooterInfo.vue'
import TextProse from '../elements/TextProse.vue'
import PageMain from '../elements/PageMain.vue'
import HeroImage from '../components/HeroImage.vue'
import ShareLinksArticle from '../components/ShareLinksArticle.vue'
import RelatedArticles from '../components/RelatedArticles.vue'
import CardDownload from '../components/CardDownload.vue'
import KeyUpcomingDates from '../components/KeyUpcomingDates.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageGrid from '../elements/PageGrid.vue'
import SubMenuMobile from '../components/SubMenuMobile.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'Article',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    SubMenuMobile,
    PageGrid,
    PageSide,
    SideNav,
    KeyUpcomingDates,
    CardDownload,
    RelatedArticles,
    ShareLinksArticle,
    HeroImage,
    PageMain,
    TextProse,
    FooterInfo,
    TheFooter
  }
}
</script>
